import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonBold from 'components/atoms/Editors/EditorMenuButtonBold/EditorMenuButtonBold.styles';

const EditorMenuButtonBold = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonBold');

  return <StyledEditorMenuButtonBold buttonRef={ref} {...innerProps} />
});

EditorMenuButtonBold.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonBold;
